var RenderLevel;
(function(RenderLevel2) {
  RenderLevel2[RenderLevel2["CLIENT_RENDER"] = 0] = "CLIENT_RENDER";
  RenderLevel2[RenderLevel2["SERVER_PREFETCH"] = 1] = "SERVER_PREFETCH";
  RenderLevel2[RenderLevel2["SERVER_RENDER"] = 2] = "SERVER_RENDER";
})(RenderLevel || (RenderLevel = {}));
var SSR_DATA_JSON_ID = "__MODERN_SSR_DATA__";
var ROUTER_DATA_JSON_ID = "__MODERN_ROUTER_DATA__";
export {
  ROUTER_DATA_JSON_ID,
  RenderLevel,
  SSR_DATA_JSON_ID
};
